import React from 'react'
import { Grid } from '@material-ui/core'
import useStyles from './Styles'
import { IProps } from './Interface'

const Section: React.FC<IProps> = ({
  children,
  padding,
  background,
  borderRadius,
  justify,
  alignItems,
  size,
  direction
}) => {
  const classes = useStyles({ padding, background, borderRadius, size })

  return (
    <Grid container className={classes.root} direction={direction} justify={justify} alignItems={alignItems}>
      {children}
    </Grid>
  )
}

Section.defaultProps = {
  children: <span>default child</span>,
  padding: 45,
  background: 'white',
  borderRadius: {
    topLeft: 12,
    topRight: 12,
    bottomLeft: 12,
    bottomRight: 12
  },
  size: {
    width: 850
  },
  direction: 'row',
  justify: 'flex-start',
  alignItems: 'flex-start'
}

export default Section
